module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"Pending Tickets","page.description":"รายการของ Ticket ที่รอข้อมูลเพิ่มเติม ซึ่งอาจเป็นเพราะหาสาเหตุหลักยังไม่พบ หรือ ข้อมูลไม่เพียงพอ"}}')
  delete Component.options._Ctor
}
